export const en_text: Record<string, string> = {
  "Sign in to your Lulu Loyal account to access all our features.":
    "Sign in to your Lulu Loyal account to access all our features.",
  "Don't have an account?": "Don't have an account?",
  "Click here to create one.": "Click here to create one.",
  "Create Lulu Loyal Account": "Create Lulu Loyal Account",
  "Log In To Lulu Loyal": "Log In To Lulu Loyal",
  "Forgot Password?": "Forgot Password?",
  "Delete Account": "Delete Account",
  "Confirm Delete": "Confirm Delete",
  "Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.":
    "Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.",
  "Delete Permanently": "Delete Permanently",
  "Confirm Logout": "Confirm Logout",
  "Are you sure you want to logout?": "Are you sure you want to logout?",
  "Password Recovery": "Password Recovery",
  "Enter your email address to receive a login link.":
    "Enter your email address to receive a login link.",
  "Send Recovery Email": "Send Recovery Email",
  "Recovery email sent. Please check your inbox.":
    "Recovery email sent. Please check your inbox.",
  "Account updated successfully.": "Account updated successfully.",
  "Continue with Google": "Continue with Google",
  OR: "OR",
  "How Lulu Works": "How Lulu Works",
  "100% untraceable": "100% untraceable",
  "Just share the username": "Just share the username",
  "No Login Required": "No Login Required",
  "Invalid login link": "Invalid login link",
  "Signing you in...": "Signing you in...",
  Loading: "Loading",
  "Analyzing {username}": "Analyzing {username}",
  seconds: "seconds",
  "Figuring out who they follow": "Figuring out who they follow",
  "Looking at who follows them": "Looking at who follows them",
  "Figuring out who's new": "Figuring out who's new",
  "Looking for suspicious profiles": "Looking for suspicious profiles",
  "Taking a closer look": "Taking a closer look",
  "Looking through off-site content": "Looking through off-site content",
  "Analyzing behavior patterns": "Analyzing behavior patterns",
  "Checking for red flags": "Checking for red flags",
  "Wrapping up (this can take a while)": "Wrapping up (this can take a while)",
  "Finding stories": "Finding stories",
  "Loading story content": "Loading story content",
  "Processing media": "Processing media",
  "Preparing anonymous view": "Preparing anonymous view",
  Finalizing: "Finalizing",
  "User Reviews": "User Reviews",
  "Email Address": "Email Address",
  Save: "Save",
  "@username": "@username",
  "Reveal Follows": "Reveal Follows",
  "Anonymously View Stories": "Anonymously View Stories",
  "find red flags": "find red flags",
  "Best Results": "Best Results",
  "Search over a billion accounts": "Search over a billion accounts",
  "Redirecting to payment...": "Redirecting to payment...",
  "Click here if you're not redirected": "Click here if you're not redirected",
  "Logging you in...": "Logging you in...",
  "Is this legal?": "Is this legal?",
  "Lulu Loyal": "Lulu Loyal",
  LINKS: "LINKS",
  "Why Use Lulu Loyal?": "Why Use Lulu Loyal?",
  Prices: "Prices",
  Resources: "Resources",
  LEGAL: "LEGAL",
  "Privacy Policy": "Privacy Policy",
  "Terms of Use": "Terms of Use",
  "Refund Policy": "Refund Policy",
  "CONTACT US": "CONTACT US",
  "support@lululoyal.com": "support@lululoyal.com",
  "© 2025 Lulu Loyal. All Rights Reserved.":
    "© 2025 Lulu Loyal. All Rights Reserved.",
  "Manage Account": "Manage Account",
  Login: "Login",
  Anonymity: "Anonymity",
  "Secure + Untraceable": "Secure + Untraceable",
  "Security Risks": "Security Risks",
  Pricing: "Pricing",
  "Lowest Prices": "Lowest Prices",
  "Pretends to Be Free": "Pretends to Be Free",
  Speed: "Speed",
  "Fastest + Best Results": "Fastest + Best Results",
  "Slow + Poor Results": "Slow + Poor Results",
  Quality: "Quality",
  "Unmatched Accuracy": "Unmatched Accuracy",
  "Consistent Errors": "Consistent Errors",
  Features: "Features",
  "Best Features": "Best Features",
  "Limited Features": "Limited Features",
  "Insta/TikTok/Snap": "Insta/TikTok/Snap",
  "All 3": "All 3",
  "Only Instagram": "Only Instagram",
  "Everyone Else": "Everyone Else",
  "🌶️ Porn account": "🌶️ Porn account",
  "🍒 Baddie": "🍒 Baddie",
  "🍑 Spicy content": "🍑 Spicy content",
  "No Red Flags": "No Red Flags",
  "Follows back": "Follows back",
  "No follow back": "No follow back",
  "Subscribe to reveal all": "Subscribe to reveal all",
  "Follows {number} new girls": "Follows {number} new girls",
  "Follows {number} new guys": "Follows {number} new guys",
  "Follows {number} Others": "Follows {number} Others",
  "Subscribe to Reveal All": "Subscribe to Reveal All",
  "{number} RED FLAGS": "{number} RED FLAGS",
  "{number} SUS PROFILES": "{number} SUS PROFILES",
  "Updated {hours}h ago": "Updated {hours}h ago",
  "Updated just now": "Updated just now",
  "This account is private": "This account is private",
  "Notify Me": "Notify Me",
  "Reveal More": "Reveal More",
  "UPDATED {hours} HOURS AGO": "UPDATED {hours} HOURS AGO",
  "Stories from @{username}": "Stories from @{username}",
  "Refresh Stories": "Refresh Stories",
  "{number} STORIES": "{number} STORIES",
  "ANONYMOUS VIEWING": "ANONYMOUS VIEWING",
  "Subscribe to view": "Subscribe to view",
  "User Not Found": "User Not Found",
  "Try Again": "Try Again",
  "PER WEEK": "PER WEEK",
  "Unlimited access to all tools.": "Unlimited access to all tools.",
  "No commitment, cancel any time.": "No commitment, cancel any time.",
  "Free relationship anxiety guide.": "Free relationship anxiety guide.",
  "Get Unlimited Access": "Get Unlimited Access",
  "Results for": "Results for",
  "+{number} more": "+{number} more",
  "View All Recent Followers": "View All Recent Followers",
  "See Who They Followed": "See Who They Followed",
  "Recent Follows": "Recent Follows",
  "Recent Followers": "Recent Followers",
  "Thank You!": "Thank You!",
  "Your subscription is now active.": "Your subscription is now active.",
  "You now have full access to all Lulu Loyal features.":
    "You now have full access to all Lulu Loyal features.",
  "Start Analyzing": "Start Analyzing",
  "Create a Lulu Loyal account to access all our features.":
    "Create a Lulu Loyal account to access all our features.",
  "If you have an account, ": "If you have an account, ",
  "you can login by clicking here.": "you can login by clicking here.",
  "My Account": "My Account",
  "Change Email Address": "Change Email Address",
  "Change Password": "Change Password",
  "Manage Subscription": "Manage Subscription",
  "You are already subscribed": "You are already subscribed",
  "Account not found": "Account not found",
  "View All": "View All",
  Girls: "Girls",
  Guys: "Guys",
  Other: "Other",
  All: "All",
  "Lulu Loyal's FAQ": "Lulu Loyal's FAQ",
  "Step 1 - Enter a Username": "Step 1 - Enter a Username",
  "Enter a username to start the search.":
    "Enter a username to start the search.",
  "Step 2 - Anonymous Search": "Step 2 - Anonymous Search",
  "Do an untraceable, anonymous search.":
    "Do an untraceable, anonymous search.",
  "Step 3 - Best Results": "Step 3 - Best Results",
  "Receive the best results, learn the truth.":
    "Receive the best results, learn the truth.",
  "Instantly saw who my boyfriend had just followed! Got rid of soo much anxiety!":
    "Instantly saw who my boyfriend had just followed! Got rid of soo much anxiety!",
  "- Sophie": "- Sophie",
  "My ex was following Onlyfan models... like 4 of them 😭😭😭 At least I left him in time 🥲":
    "My ex was following Onlyfan models... like 4 of them 😭😭😭 At least I left him in time 🥲",
  "- Osheb": "- Osheb",
  "I noticed my SO was following a bunch of new accounts very day... turns out it was nothing, good to check.":
    "I noticed my SO was following a bunch of new accounts very day... turns out it was nothing, good to check.",
  "- Anonymous": "- Anonymous",
  "Most recent follow": "Most recent follow",
  "Loyalty analysis": "Loyalty analysis",
  "Can I trust these results?": "Can I trust these results?",
  "Yes, our tech is best in class, and it's designed to be as accurate as possible. If you can't get the results you're looking for here, you can't get them anywhere. Our tech is the most advanced.":
    "Yes, our tech is best in class, and it's designed to be as accurate as possible. If you can't get the results you're looking for here, you can't get them anywhere. Our tech is the most advanced.",
  "Is this 100% anonymous?": "Is this 100% anonymous?",
  "Yes, there's no way anyone could ever know, or see that you've searched for a person. They'll also never know you've searched for them either. We've made that our top priority.":
    "Yes, there's no way anyone could ever know, or see that you've searched for a person. They'll also never know you've searched for them either. We've made that our top priority.",
  "Can I catch cheaters with this?": "Can I catch cheaters with this?",
  "Yes, many people have, and many people have stopped themselves landing in heartbreak. You can use Lulu Loyal to make sure you're not interacting with people who will mess you around.":
    "Yes, many people have, and many people have stopped themselves landing in heartbreak. You can use Lulu Loyal to make sure you're not interacting with people who will mess you around.",
  "All the data we gather is public and it's 100% legal to collect this data, and to interact with this data too. You're not doing anything which breaks any law anywhere by searching for someone.":
    "All the data we gather is public and it's 100% legal to collect this data, and to interact with this data too. You're not doing anything which breaks any law anywhere by searching for someone.",
  "Why should I trust Lulu Loyal?": "Why should I trust Lulu Loyal?",
  "Because we've been in your shoes, which is exactly why we built this product. What matters most to us, is to help other people find good people that won't mess them around.":
    "Because we've been in your shoes, which is exactly why we built this product. What matters most to us, is to help other people find good people that won't mess them around.",
  "Unlimited Searches.": "Unlimited Searches.",
  "No Commitment. Cancel Anytime.": "No Commitment. Cancel Anytime.",
  "Search 100% Anonymously.": "Search 100% Anonymously.",
  "Relieve Anxiety. Learn the Truth.": "Relieve Anxiety. Learn the Truth.",
  "Discreet Billing. No Reference.": "Discreet Billing. No Reference.",
  "Easy to Cancel": "Easy to Cancel",
  "Secured by Stripe Payments": "Secured by Stripe Payments",
  "100% anonymous and untraceable.": "100% anonymous and untraceable.",
  "Search Again": "Search Again",
  "Do you want to try another username?":
    "Do you want to try another username?",
  "Search TikTok": "Search TikTok",
  "We couldn't find @{username}": "We couldn't find @{username}",
  "Dating App Tracker": "Dating App Tracker",
  Investigate: "Investigate",
  "Select a location": "Select a location",
  "Upload Images": "Upload Images",
  "Feature Not Available Yet": "Feature Not Available Yet",
  "This feature is not implemented yet. For early access, please email":
    "This feature is not implemented yet. For early access, please email",
  "Search Reddit History": "Search Reddit History",
  "JOIN OVER 10,000 HAPPY USERS": "JOIN OVER 10,000 HAPPY USERS",
  "Learn the truth with full,": "Learn the truth with full,",
  "unlimited access": "unlimited access",
  "to Lulu Loyal.": "to Lulu Loyal.",
  "Become Elite": "Become Elite",
  "/week": "/week",
  "Follows {number} Red Flags": "Follows {number} Red Flags",
  "REVEAL 200 MORE": "REVEAL 200 MORE",
  "WHAT YOU GET": "WHAT YOU GET",
  WEEK: "WEEK",
  MONTH: "MONTH",
  "(SAVE 30%)": "(SAVE 30%)",
  "See recent follows": "See recent follows",
  "Sign in with Email": "Sign in with Email",
  "TOOLS BY LULU LOYAL": "TOOLS BY LULU LOYAL",
  "Tools to keep tabs without saying a word.":
    "Tools to keep tabs without saying a word.",
    "100% anonymous": "100% anonymous",
    "Cancel anytime": "Cancel anytime",
    "Risky accounts they follow": "Risky accounts they follow"
};
